export const convertType = (value) => Number(value);

export function formatPrice(amount, currency = 'USD', byMonth = false) {
  const price = amount / 100; // Convert cents to dollars
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  })
    .format(byMonth ? price / 12 : price)
    .replace(/\.00$/, '');
}

// Copy rule: currency code first — "USD $119.99", never "$119.99/año".
export function formatPriceWithCode(amount, currency = 'USD', byMonth = false) {
  return `${currency} ${formatPrice(amount, currency, byMonth)}`;
}

export const getTrialEndDate = (daysFromNow, language) => {
  const trialEndDate = new Date();
  trialEndDate.setDate(trialEndDate.getDate() + daysFromNow);

  return trialEndDate.toLocaleDateString(language, { month: 'long', day: 'numeric' });
};
